export default __webpack_public_path__ + "static/media/searchMark.77089237.svg";